<template>
  <Dialog ref="savingDialog">
    <template #expander>
      <ButtonCustomized
        label="Save"
        @click="savePlayerSubscription"
        :disabled="!hasUnsavedChanges"
      />
    </template>
    <template #dialog.title>Saving</template>
    <template #dialog.content="{closeModal, closeModalAfter}">
      <div class="saving-progress-dialog-content">
        <!-- TODO: think about adding height option for StatusBar — N2LBs3CL -->
        <StatusBar
          :errorMessage="errorMessage"
          :isLoading="isLoading"
          loadingMessage="Saving..."
          :isSuccess="isSuccess"
          successMessage="Saved!"
        />
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import useNotifications from '@/components/Notifications/composables/notifications';
import { usePlayerSubscription } from '../composables/playerSubscription';
import { useSavePlayerSubscriptionFormHelpers } from '../composables/saveSubscriptionFormHelpers';
import { ref } from 'vue';

const emit = defineEmits(['save']);
defineExpose({
  savePlayerSubscription
})

const notification = useNotifications();
const {
  submitForm,
  isSuccess,
  errorMessage,
  isLoading,
  responseData
} = useSavePlayerSubscriptionFormHelpers();
const {
  hasUnsavedChanges,
  unsetHasUnsavedChanges,
  transformFetchedPlayerSubscription,
} = usePlayerSubscription();

const savingDialog = ref();

async function savePlayerSubscription() {
  
  try {
    savingDialog.value.openModal();
    await submitForm();

    /**
     * Update local data with the response data in order to fill-in the new bindings ids
     * This is important in order not to create new bindings when saving the subscription when new bindings are added
     */
    const transformedResponseData = transformFetchedPlayerSubscription(responseData.value.data);
    emit('save', transformedResponseData);
    // console.log({ responseData: responseData.value, transformedResponseData, data: data }); // Debugging Helper
    if(isSuccess.value === true) {
      notification.success('Player Subscription saved successfuly!');
      // Important to set in timeout to queue it after any post-save state updates that are done (e.g. we update data object with response data for in case there are any bindings that were added).
      setTimeout(() => {
        unsetHasUnsavedChanges({resetDataInitializationState: false});
        savingDialog.value.closeModalAfter(1000);
      })
    } else {    // on failure
      notification.failure('Player Subscription saving failed!');
    }
  } catch (error) {
    console.error(error);
    notification.failure('Player Subscription saving failed!');
  }
}


</script>

<style lang="scss" scoped>
.saving-progress-dialog-content {
  min-height: 60px;
  min-width: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}
</style>